import { StatusPill, type StatusPillSize } from '@/components/ui/status-pill';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

interface ResurrectionPenaltyBadgeProps {
  /** SRD 2024 resurrection penalty: -N to all d20 tests. */
  penalty: number;
  size?: StatusPillSize;
  className?: string;
}

/**
 * Compact orange pill showing just the penalty number (e.g. "-4"), with the
 * full explanation on hover. Matches ConditionBadge's tooltip-on-hover shape.
 */
export function ResurrectionPenaltyBadge({
  penalty,
  size = 'sm',
  className,
}: ResurrectionPenaltyBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <StatusPill
            size={size}
            className={`bg-orange-600 text-white cursor-help ${className ?? ''}`}
          >
            -{penalty}
          </StatusPill>
        </TooltipTrigger>
        <TooltipContent>
          <div>-{penalty} to all D20 Tests, reduced by 1 after each long rest</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
